import axiosAuth from '../../axiosMain';

async function show(question_type_id, data = {}) {
  try {
    let response = await axiosAuth.post('/question_has_type/' + question_type_id, data);
    return response.data;
  } catch (e) {}
}

export default {
  show,
};
